module.exports = __webpack_public_path__ + "static/media/joji.7e91f9bf.png";